export default __webpack_public_path__ + "static/media/capcoreeWeb.c524c014.png";